import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
  Navigate,
} from 'react-router-dom';

import {VeiledereProvider} from './context/VeilederContext';
import VeilederScreen from './pages/VeilederScreen';
import KravScreen from './pages/KravScreen';
import FagScreen from './pages/FagScreen';
import SkikkethetScreen from './pages/SkikkethetScreen';
import React from 'react';

function Navigation() {
  return (
    <VeiledereProvider>
      <Router>
        <div className="tabContainer">
          <nav className="tabBar">
            <NavLink
              to="/veiledere"
              className={({isActive}) => (isActive ? 'tab active' : 'tab')}>
              Veiledere
            </NavLink>
            <NavLink
              to="/krav"
              className={({isActive}) => (isActive ? 'tab active' : 'tab')}>
              Krav
            </NavLink>
            <NavLink
              to="/fag"
              className={({isActive}) => (isActive ? 'tab active' : 'tab')}>
              Fagområder
            </NavLink>
            <NavLink
              to="/skikkethet"
              className={({isActive}) => (isActive ? 'tab active' : 'tab')}>
              Skikkethet
            </NavLink>
          </nav>
        </div>

        <div className="contentContainer">
          <Routes>
            <Route path="/veiledere" element={<VeilederScreen />} />
            <Route path="/krav" element={<KravScreen />} />
            <Route path="/fag" element={<FagScreen />} />
            <Route path="/skikkethet" element={<SkikkethetScreen />} />

            <Route path="*" element={<Navigate to="/veiledere" replace />} />
          </Routes>
        </div>
      </Router>
    </VeiledereProvider>
  );
}

export default Navigation;
